import { useMemo, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getCurrencyForCountry } from "../utils/countryCurrencyMap";
import { getUser, getCurrency } from "../services/localService";
import logger from "../utils/logger";


/**
 * Hook to get the logged-in user's preferred currency
 * Based on their country setting
 * Reactive to changes from debug test dropdown
 * @returns {string} ISO 4217 currency code (e.g., 'GHS', 'KES', 'NGN')
 */
export const useUserCurrency = () => {
  const countries = useSelector(state => state.dashboard?.countries || []);
  const [trigger, setTrigger] = useState(0);

  // Listen for currency changes (from debug test dropdown)
  useEffect(() => {
    const handleCurrencyChange = () => {
      setTrigger(prev => prev + 1);
    };

    window.addEventListener("currencyChanged", handleCurrencyChange);
    return () => window.removeEventListener("currencyChanged", handleCurrencyChange);
  }, []);

  const userCurrency = useMemo(() => {
    try {
      // Check for debug test country first (from test dropdown)
      const debugTestCountry = localStorage.getItem("debug_test_country");
      if (debugTestCountry) {
        const testCountryId = parseInt(debugTestCountry);
        if (countries.length > 0) {
          const testCountry = countries.find(c => c.id === testCountryId);
          if (testCountry?.code) {
            return getCurrencyForCountry(testCountry.code);
          }
        }
      }

      // Check for manually set currency
      const storedCurrency = getCurrency();
      if (storedCurrency) {
        return storedCurrency;
      }

      // Fall back to user's country
      const currentUser = getUser();
      const userCountryId = currentUser?.countryId || currentUser?.organization?.countryId;

      logger.log("gjfkkrjejrjr [useUserCurrency] 💰 User countryId:", currentUser?.countryId);
      logger.log("gjfkkrjejrjr [useUserCurrency] 💰 Organization countryId:", currentUser?.organization?.countryId);
      logger.log("gjfkkrjejrjr [useUserCurrency] 💰 Final userCountryId:", userCountryId);

      if (!userCountryId) {
        logger.log("gjfkkrjejrjr [useUserCurrency] 💰 No countryId found, defaulting to KES");
        return "KES";
      }

      if (countries.length > 0) {
        const userCountry = countries.find(c => c.id === userCountryId);
        logger.log("gjfkkrjejrjr [useUserCurrency] 💰 Found country:", userCountry);
        if (userCountry?.code) {
          const currency = getCurrencyForCountry(userCountry.code);
          logger.log("gjfkkrjejrjr [useUserCurrency] 💰 Returning currency:", currency);
          return currency;
        }
      }

      logger.log("gjfkkrjejrjr [useUserCurrency] 💰 Countries not loaded or country not found, defaulting to KES");
      return "KES";
    } catch (error) {
      logger.error("Error getting user currency:", error);
      return "KES";
    }
  }, [countries, trigger]);

  return userCurrency;
};
